import { createRoot } from "react-dom/client";
import { useEffect } from "react";
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

console.log('[Sentry] DSN present:', !!import.meta.env.VITE_SENTRY_DSN,
  '| MODE:', import.meta.env.MODE,
  '| PROD:', import.meta.env.PROD);

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  sendDefaultPii: false,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],
});

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={<div>Something went wrong. Please refresh the page.</div>}
  >
    <App />
  </Sentry.ErrorBoundary>
);
